import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';

import { ACL_PERMISSIONS_STALE_TIME, type AclScope, aclSearchParams, useAggregateQuery } from '~/queryUtils/useQuery';
import { buildAclPermissions } from '~/utils/buildAclPermissions';

const PLACEHOLDER_LOADING = buildAclPermissions(true);
const PLACEHOLDER_FAIL_CLOSED = buildAclPermissions(false);

export function useAclPermissions(params?: AclScope) {
    const searchParams = aclSearchParams(params ?? {});

    const query = useAggregateQuery({
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getAclPermissions,
        schema: schemaUserResolver_GetAclPermissions,
        searchParams,
        tanstack: {
            placeholderData: () => PLACEHOLDER_LOADING,
            staleTime: ACL_PERMISSIONS_STALE_TIME,
        },
    });
    const permissions = query.data ?? (query.isPending ? PLACEHOLDER_LOADING : PLACEHOLDER_FAIL_CLOSED);
    return {
        ...query,
        permissions,
    };
}
